<template>
  <div>
    <v-row align="center">

      <!-- Coluna esquerda: conteúdo -->
      <v-col cols="12" lg="6">
        <SectionTitle>Pronto para Iniciar?</SectionTitle>

        <p class="subtitle mt-4">
          Nosso atendimento é <strong>100% humanizado</strong> e isso nunca irá mudar!
        </p>

        <!-- Badge garantia -->
        <div class="guarantee-badge-wrap mt-6">
          <img
            :src="require('@/assets/images/garantia.png')"
            class="guarantee-badge"
            loading="lazy"
            alt="Garantia 30 dias"
          />
        </div>

        <!-- Card Risco Zero -->
        <div class="risk-card mt-6">
          <div class="risk-card__header">
            <v-icon color="success" class="mr-2">mdi-shield-check</v-icon>
            <span class="risk-card__label">Risco Zero</span>
          </div>
          <p class="risk-card__text">
            Você tem <strong>30 dias</strong> de satisfação garantida ou seu dinheiro de volta.
            Sem pegadinhas, sem surpresas — queremos que você sinta os benefícios antes de qualquer compromisso.
          </p>
        </div>

        <!-- Pills de benefícios -->
        <div class="perks mt-6">
          <span class="perk-pill">
            <v-icon small class="mr-1">mdi-play-circle-outline</v-icon>
            Videoaulas inclusas
          </span>
          <span class="perk-pill">
            <v-icon small class="mr-1">mdi-whatsapp</v-icon>
            Suporte pelo WhatsApp
          </span>
          <span class="perk-pill">
            <v-icon small class="mr-1">mdi-clock-outline</v-icon>
            Atendimento 08h–22h
          </span>
        </div>

        <div class="mt-8">
          <CtaButton v-if="getPrice > 0">Quero Garantir por R${{ getPrice }}</CtaButton>
          <CtaButton v-else>Quero Saber Mais</CtaButton>
        </div>
      </v-col>

      <!-- Coluna direita: foto -->
      <v-col cols="12" lg="6">
        <img
          :src="$vuetify.theme.dark
            ? require('@/assets/images/equipe-black.webp')
            : require('@/assets/images/equipe-white.webp')"
          class="team-img"
          :class="{ 'team-img--dark': $vuetify.theme.dark }"
          loading="lazy"
          alt="Equipe ZaperMenu"
        />
      </v-col>

    </v-row>
  </div>
</template>

<script>
  import SectionTitle from "@/components/SectionTitle.vue";
  import CtaButton from "@/components/CtaButton.vue";
  import { mapState } from 'vuex';

  export default {
    name: "GuaranteeSection",

    components: {
      SectionTitle,
      CtaButton,
    },

    computed: {
      ...mapState(['plan']),

      getPrice() {
        return this.plan.price;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .subtitle {
    font-size: 17px;
    font-weight: 400;
    line-height: 1.7;
    color: var(--text-secondary);
  }

  /* Badge com glow dourado pulsante */
  .guarantee-badge-wrap {
    display: flex;
    justify-content: flex-start;
  }

  .guarantee-badge {
    height: 130px;
    filter: drop-shadow(0 0 8px rgba(212, 175, 55, 0.4));
    animation: badge-glow 3s ease-in-out infinite;
  }

  @keyframes badge-glow {
    0%, 100% { filter: drop-shadow(0 0 6px rgba(212, 175, 55, 0.35)); }
    50%       { filter: drop-shadow(0 0 18px rgba(212, 175, 55, 0.7)); }
  }

  /* Card Risco Zero */
  .risk-card {
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    border-left: 3px solid #23cf65;
    border-radius: 14px;
    padding: 18px 20px;

    &__header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    &__label {
      font-size: 16px;
      font-weight: 700;
      color: #23cf65;
    }

    &__text {
      font-size: 15px;
      line-height: 1.65;
      color: var(--text-secondary);
      margin: 0;
    }
  }

  /* Pills */
  .perks {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .perk-pill {
    display: inline-flex;
    align-items: center;
    padding: 6px 14px;
    border-radius: 999px;
    border: 1px solid var(--card-border);
    background: var(--card-bg);
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    white-space: nowrap;
  }

  /* Foto da equipe */
  .team-img {
    max-height: 600px;
    max-width: 100%;
    border-radius: 20px;
    display: block;

    &--dark {
      box-shadow: 0 16px 48px rgba(0, 0, 0, 0.45);
    }
  }
</style>
